import { axInstBasic } from "../Service/Service";

export const fetchAccountName = async () => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getAccountName`,
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchKACode = async () => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getKACode`,
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchArnNumber = async () => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getArnNumber`,
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCompCountData = async (searchData) => {
  // console.log(searchData,'res data---------------');
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintCountData`,{searchData}
    );
    // console.log(searchData,'res data---------------');
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchComplaintQuarterlyData = async (setSearchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintQuarterly`,{setSearchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};